// ── Does this member hold that permission? ────────────────────────────
//
// ⚠️ THE BROWSER HAS TO EXPAND WILDCARDS ITSELF. team-me ships ctx.perms RAW:
// resolve-account expands '*' and 'leads.*' inside has(), not in the map it
// hands to the browser. So `'leads.view' in perms` is FALSE for somebody whose
// role holds '*' — and the shipped Admin role holds exactly one permission,
// which is '*'.
//
// That cost the whole feature. Admin is the default in the invite dropdown, so
// the first person a coach invited signed in to a sidebar with every button
// hidden but Settings, no invite box, and no roles card — while every server
// endpoint would have answered them perfectly. Five separate call sites each
// wrote `key in perms` and each got it wrong the same way, which is why this
// is one function now instead of a sixth copy.
//
// Kept deliberately in step with resolve-account.js's wildFor/has: exact key,
// then the global '*', then the area wildcard. This decides what a member SEES.
// It is not a lock — the server's own check is the lock — so being generous
// here shows a button the endpoint may still refuse, which is the safe way for
// the two to disagree.

/**
 * @param {Record<string, string>|null|undefined} perms the raw map from team-me
 * @param {string} key a permission key, e.g. 'leads.view'
 * @returns whether the member holds it, wildcards included
 */
export function memberHasPerm(perms, key) {
  if (!perms || !key) return false;
  if (key in perms) return true;
  if (perms['*'] != null) return true;
  return perms[`${key.split('.')[0]}.*`] != null;
}
